// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".project-files-list-page__card{min-height:85dvh;display:flex;flex-wrap:wrap;border:1px solid var(--border-color);border-radius:var(--border-radius-lg)}@media screen and (max-width:992px){.project-files-list-page__card{min-height:auto}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
